import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import CloudflareImage from './ui/cloudflare-image';

const LogoContainer = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  height: 100%;
  gap: 8px;
`;

const LogoWrapper = styled.div`
  width: 144px;
  display: inline-block;
  cursor: pointer;
  
  @media (min-width: 1024px) {
    width: 192px;
  }
`;

const LogoImage = styled(CloudflareImage)`
  max-width: 100%;
  width: 100%;
`;

const Logo = () => {
  return (
    <LogoContainer to="/">
      <LogoWrapper>
        <LogoImage src="/images/TMZ L.png" alt="TMZ Logo" />
      </LogoWrapper>
    </LogoContainer>
  );
};

export default Logo; 